import { Injectable } from '@angular/core';
import { AbstractPaymentHistoryViewService } from './payment-history.abstract.service';

@Injectable()
export class PaymentHistoryViewService extends AbstractPaymentHistoryViewService {}
